import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

@observer
class SpectrumAnalyzer extends Component {
    constructor(props) {
        super(props);
        this.canvasRef = null;
        this.rafId = null;
    }

    componentDidMount() {
        this.startLoop();
    }

    componentWillUnmount() {
        this.stopLoop();
    }

    startLoop = () => {
        if (this.rafId) return;
        const tick = () => {
            this.draw();
            this.rafId = requestAnimationFrame(tick);
        };
        this.rafId = requestAnimationFrame(tick);
    }

    stopLoop = () => {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }
    }

    draw = () => {
        const canvas = this.canvasRef;
        if (!canvas) return;
        const { shotTrainerStore } = this.props.stores;
        const analyser = shotTrainerStore && shotTrainerStore.analyser;
        const ctx = canvas.getContext('2d');
        const w = canvas.width;
        const h = canvas.height;
        ctx.clearRect(0, 0, w, h);
        if (!analyser) return;
        const bins = analyser.frequencyBinCount;
        const data = new Uint8Array(bins);
        analyser.getByteFrequencyData(data);
        // Use only the lower half — voice spectrum sits there.
        const useBins = Math.floor(bins / 2);
        const gap = 2;
        const totalGap = gap * (useBins - 1);
        const barWidth = (w - totalGap) / useBins;
        const color = this.props.color || '#0d6efd';
        ctx.fillStyle = color;
        for (let i = 0; i < useBins; i += 1) {
            const value = data[i] / 255;
            const barHeight = Math.max(2, value * h);
            const x = i * (barWidth + gap);
            const y = h - barHeight;
            ctx.fillRect(x, y, barWidth, barHeight);
        }
    }

    render() {
        const { shotTrainerStore } = this.props.stores;
        const { activePlaybackCount } = shotTrainerStore || { activePlaybackCount: 0 };
        const visible = activePlaybackCount > 0;
        const { width = 220, height = 36 } = this.props;
        return (
            <canvas
                ref={c => { this.canvasRef = c; }}
                width={width}
                height={height}
                style={`opacity: ${visible ? 1 : 0}; transition: opacity 200ms ease; width: ${width}px; height: ${height}px; display: block;`}
            />
        );
    }
}

export default SpectrumAnalyzer;
